import { JSX } from 'react';
import { WarningIcon } from '@bg-components/Icon';
import { envConfig } from '@bg-shared';
import classes from './GeneralError.module.scss';

interface IProps {
    message?: string;
}

export const GeneralError = (props: IProps): JSX.Element => (
    <div className={classes.container}>
        <WarningIcon className={classes.icon} />
        {envConfig.isDevEnv || envConfig.isStagingEnv
            ? props.message
            : 'Something unexpected happened.'}
    </div>
);
